import React from "react";

import Dialog from '@mui/material/Dialog';

export default function ImageViewer({ open, url, onClose, maxHeight }) {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" style={{overflow: 'hidden'}} >
        <img 
          alt=""
          src={url} 
          loading="lazy" 
          style={{ 
            maxHeight: maxHeight ? maxHeight : '70vh',    
            maxWidth: '100%',
            objectFit: 'contain'
          }}
        />
    </Dialog>
  );
}
